import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen w-full bg-gray-100" }
const _hoisted_2 = { class: "mx-auto flex w-full max-w-7xl flex-col px-4 py-6 sm:px-6 lg:px-8" }

import CabinetHeader from "@/components/blocks/CabinetHeader.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CabinetHeader),
    _createElementVNode("main", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})